import _axios from "@/axios";
import { reactive, ref } from "@vue/composition-api";

const logsradius = ref({});

export function useLogRadius() {
  let logradiusData = reactive({
    options: {
      itemsPerPage: 100,
    },
    firstLoad: true,
    isLoading: false,
    operationChoices: [
      "ACCT_UPDT",
      "ACCT_UPD",
      "AUTH_POST",
      "AUTH_POST",
      "AUTH_REPL",
      "AUTH_REPL",
      "AUTH_REQ",
      "AUTH_REQ",
      "ACCT_STOP",
      "ACCT_STOP",
      "ACCT_START",
      "ACCT_START",
    ],
    replyChoices: ["Access-Accept", "Access-Reject"],
    accountTerminateCauseChocies: [
      "User-Request",
      "Lost-Carrier",
      "Lost-Service",
      "Idle-Timeout",
      "Session-Timeout",
      "Admin-Reset",
      "Admin-Reboot",
      "Port-Error",
      "Nas-Error",
      "Nas-Request",
      "Nas-Reboot",
      "Port-Unneeded",
      "Port-Preempted",
      "Port-Suspended",
      "Service-unvailable",
      "Callback",
      "User-Error",
      "Host-Request",
    ],
    accountStatusTypeChoices: ["stop", "start", "Interim-Update"],
  });
  function listLogradius(nasIdentifier, filters = null) {
    logradiusData.isLoading = true;

    const params = new URLSearchParams();

    params.set("page", logradiusData.options.page ?? 1);
    params.set("itemsPerPage", logradiusData.options.itemsPerPage ?? 10);

    if (filters != null) {
      if (filters.username != "" && filters.username != undefined) {
        params.set("username", filters.username.trim());
      }
      if (filters.createdAt != "" && filters.createdAt != undefined) {
        params.set("createdAt[after]", filters.createdAt.trim());
      }
      if (
        filters.clientIpAddress != "" &&
        filters.clientIpAddress != undefined
      ) {
        params.set("clientIpAddress", filters.clientIpAddress.trim());
      }
      if (
        filters.callingStationId != "" &&
        filters.callingStationId != undefined
      ) {
        params.set("callingStationId", filters.callingStationId.trim());
      }

      if (
        filters.accountStatusType != "" &&
        filters.accountStatusType != undefined &&
        filters.accountStatusType.length > 0
      ) {
        params.append(
          "accountStatusType[in]",
          filters.accountStatusType.join("|")
        );
      }

      if (
        filters.accountTerminateCause != "" &&
        filters.accountTerminateCause != undefined &&
        filters.accountTerminateCause.length > 0
      ) {
        params.append(
          "accountTerminateCause[in]",
          filters.accountTerminateCause.join("|")
        );
      }

      if (
        filters.replyPacketType != "" &&
        filters.replyPacketType != undefined &&
        filters.replyPacketType.length > 0
      ) {
        params.append("replyPacketType[in]", filters.replyPacketType.join("|"));
      }

      if (
        filters.operation != "" &&
        filters.operation != undefined &&
        filters.operation.length > 0
      ) {
        params.append("operation[in]", filters.operation.join("|"));
      }
    }

    return _axios
      .get("/list-logradius/" + nasIdentifier + "?" + params.toString())
      .then((response) => {
        logsradius.value = response.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      })
      .finally(() => {
        logradiusData.isLoading = false;
        logradiusData.firstLoad = false;
      });
  }

  function listLogradiusForCard(cardId) {
    logradiusData.isLoading = true;

    const params = new URLSearchParams();

    params.set("page", logradiusData.options.page ?? 1);
    params.set("itemsPerPage", logradiusData.options.itemsPerPage ?? 10);

    return _axios
      .get("/list-logradius-card/" + cardId + "?" + params.toString())
      .then((response) => {
        logsradius.value = response.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      })
      .finally(() => {
        logradiusData.isLoading = false;
        logradiusData.firstLoad = false;
      });
  }

  return {
    logradiusData,
    logsradius,
    listLogradius,
    listLogradiusForCard,
  };
}
